module.exports = __webpack_public_path__ + "static/media/return.64e97270.svg";